/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListConnectionViewData } from './genericApiResponseListConnectionViewData';
import type { GenericApiResponseListConnectionViewMessage } from './genericApiResponseListConnectionViewMessage';
import type { GenericApiResponseListConnectionViewPagination } from './genericApiResponseListConnectionViewPagination';
import type { GenericApiResponseListConnectionViewError } from './genericApiResponseListConnectionViewError';

export interface GenericApiResponseListConnectionView {
  data?: GenericApiResponseListConnectionViewData;
  message?: GenericApiResponseListConnectionViewMessage;
  pagination?: GenericApiResponseListConnectionViewPagination;
  error?: GenericApiResponseListConnectionViewError;
  statusCode?: number;
}
